// Photo coach: mirrors the backend image gates (quality.py) in the browser so a shop
// sees a thumbs-up (or the exact problem) BEFORE anything is uploaded.
export const IMG_MIN_WIDTH = 800;
export const IMG_MIN_HEIGHT = 500;
const MIN_SHARPNESS = 45;
const MIN_CONTRAST = 12;

const loadBitmap = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("unreadable")); };
  img.src = url;
});

export const checkPhoto = async (file) => {
  let img;
  try { img = await loadBitmap(file); }
  catch { return { ok: false, code: "img_unreadable", params: {} }; }
  const w = img.naturalWidth, h = img.naturalHeight;
  if (w < IMG_MIN_WIDTH || h < IMG_MIN_HEIGHT) {
    return { ok: false, code: "coachSmall", params: { w, h, minW: IMG_MIN_WIDTH, minH: IMG_MIN_HEIGHT } };
  }
  const cw = Math.min(512, w);
  const ch = Math.max(1, Math.round((h * cw) / w));
  const canvas = document.createElement("canvas");
  canvas.width = cw; canvas.height = ch;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, cw, ch);
  const { data } = ctx.getImageData(0, 0, cw, ch);
  const gray = new Float64Array(cw * ch);
  let sum = 0;
  for (let i = 0, p = 0; i < data.length; i += 4, p++) {
    const g = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    gray[p] = g; sum += g;
  }
  const mean = sum / gray.length;
  let variance = 0;
  for (let i = 0; i < gray.length; i++) variance += (gray[i] - mean) ** 2;
  const contrast = Math.sqrt(variance / gray.length);
  if (contrast < MIN_CONTRAST) return { ok: false, code: "coachBlank", params: {} };
  // Variance of the Laplacian = focus measure (same formula the backend uses).
  let lSum = 0, lSumSq = 0, n = 0;
  for (let y = 1; y < ch - 1; y++) {
    for (let x = 1; x < cw - 1; x++) {
      const i = y * cw + x;
      const lap = -4 * gray[i] + gray[i - 1] + gray[i + 1] + gray[i - cw] + gray[i + cw];
      lSum += lap; lSumSq += lap * lap; n++;
    }
  }
  const lMean = n ? lSum / n : 0;
  const sharpness = n ? lSumSq / n - lMean * lMean : 0;
  if (sharpness < MIN_SHARPNESS) return { ok: false, code: "coachBlurry", params: {} };
  return { ok: true, code: "coachGood", params: {}, sharpness: Math.round(sharpness), contrast: Math.round(contrast) };
};
